module.exports = __webpack_public_path__ + "static/media/widget5-img3.ff824c71.jfif";